import { render, staticRenderFns } from "./ObjektOfTraplinkedDevice.vue?vue&type=template&id=4a9a5791"
import script from "./ObjektOfTraplinkedDevice.vue?vue&type=script&lang=js"
export * from "./ObjektOfTraplinkedDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports